import useAuthStore from './store'
import AuthMessages from './localization'

export default {
  useAuthStore,
  localization: AuthMessages,
}
